import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const options = {
  responsive: true,
  maintainAspectRatio: true,
  scales: {
    x: {
      ticks: { color: "rgb(199, 238, 255)" },
      grid: { color: "rgb(70, 130, 180)" }
    },
    y: {
      beginAtZero: true,
      ticks: { color: "rgb(199, 238, 255)", precision: 0 },
      grid: { color: "rgb(70, 130, 180)" }
    }
  },
  plugins: {
    legend: { display: false }
  }
};

type Props = {
  countsByHour: number[];
};

const EpicRunsByHourChart = ({ countsByHour }: Props) => {
  const labels = countsByHour.map((_, hour) => `${hour}:00`);

  return (
    <Bar
      options={options}
      data={{
        labels,
        datasets: [
          {
            data: countsByHour,
            borderColor: "#796dce",
            backgroundColor: "#393e6f"
          }
        ]
      }}
    />
  );
};

export default EpicRunsByHourChart;
